module.exports = __webpack_public_path__ + "img/imagem-02-detalhada-palmeiras-01.3d010811.png";